import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { brandInfo, faqList } from '@/mocks/data';

const milestones = [
  { year: '2023.03', title: '平台成立', desc: '17吃瓜正式上线，定位网红八卦与娱乐黑料聚合平台，首月用户突破10万。' },
  { year: '2023.09', title: '百万用户', desc: '凭借独家爆料的快速更新和严格的信源核查，用户规模半年内突破100万。' },
  { year: '2024.04', title: '行业标杆', desc: '被多家科技媒体评为年度最佳娱乐资讯平台，日均访问量突破200万。' },
  { year: '2024.11', title: '千万里程碑', desc: '累计注册用户突破2000万，成为国内吃瓜资讯领域第一入口。' },
  { year: '2025.06', title: '内容升级', desc: '上线独家调查报道栏目，组建专业编辑团队，覆盖网红、直播、短视频全领域。' },
  { year: '2026.01', title: '全面爆发', desc: '日均访问用户突破500万，累计独家报道超10000篇，稳居行业领先地位。' },
];

const coopTypes = [
  { icon: 'ri-advertisement-line', title: '广告合作', desc: '品牌广告投放、原生内容植入、定制专题合作，精准触达千万吃瓜用户群体。' },
  { icon: 'ri-shake-hands-line', title: '内容合作', desc: '自媒体内容分发、独家爆料联合报道、IP联合运营，共同打造吃瓜内容生态。' },
  { icon: 'ri-megaphone-line', title: '品牌推广', desc: '事件营销策划、品牌舆情监测、危机公关顾问，借助吃瓜流量实现品牌破圈传播。' },
  { icon: 'ri-user-star-line', title: '人才招聘', desc: '编辑记者、视频剪辑、运营策划等岗位长期招聘，加入我们，一起吃瓜吃出新高度。' },
];

export default function AboutPage() {
  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '17吃瓜',
    url: 'http://whzjzcgs.cn/',
    description: '17吃瓜是国内领先的网红八卦与娱乐黑料实时更新平台，聚合全网最新最全的吃瓜资讯。',
    foundingDate: '2023',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'hello@whzjzcgs.cn',
      contactType: '爆料投稿',
    },
    sameAs: ['http://whzjzcgs.cn/'],
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqList.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  const breadcrumbSchema = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'http://whzjzcgs.cn/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'http://whzjzcgs.cn/about' },
    ],
  };

  return (
    <>
      <Navbar />
      <main>
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbSchema) }}
        />

        {/* Hero / Brand Intro */}
        <section className="relative w-full pt-16">
          <div className="bg-background-200">
            <div className="container-page py-10 md:py-16">
              <div className="flex flex-col lg:flex-row gap-8 items-start">
                <div className="lg:w-[55%]">
                  <nav className="flex items-center gap-2 text-xs text-secondary-400 mb-4" aria-label="面包屑导航">
                    <Link to="/" className="hover:text-foreground-800 transition-colors cursor-pointer">首页</Link>
                    <i className="ri-arrow-right-s-line"></i>
                    <span className="text-primary-400">关于我们</span>
                  </nav>
                  <span className="inline-block bg-primary-500/20 text-primary-500 text-xs px-2.5 py-1 rounded-full mb-4">
                    品牌介绍
                  </span>
                  <h1 className="text-2xl md:text-4xl font-extrabold text-foreground-950 leading-tight mb-6">
                    全网热点追踪
                    <br />
                    网红塌房实录
                    <br />
                    <span className="text-primary-500">24h独家爆料</span>
                  </h1>
                  <p className="text-secondary-500 text-sm leading-relaxed mb-8 max-w-lg">
                    {brandInfo.description}
                  </p>
                  <div className="grid grid-cols-3 gap-4">
                    <div className="text-center p-3 bg-background-300/60 rounded-lg">
                      <p className="text-2xl md:text-3xl font-bold text-primary-500">{brandInfo.visitors}</p>
                      <p className="text-secondary-500 text-xs mt-1">日均访问用户</p>
                    </div>
                    <div className="text-center p-3 bg-background-300/60 rounded-lg">
                      <p className="text-2xl md:text-3xl font-bold text-primary-500">{brandInfo.articles}</p>
                      <p className="text-secondary-500 text-xs mt-1">累计独家报道</p>
                    </div>
                    <div className="text-center p-3 bg-background-300/60 rounded-lg">
                      <p className="text-2xl md:text-3xl font-bold text-primary-500">{brandInfo.users}</p>
                      <p className="text-secondary-500 text-xs mt-1">注册用户</p>
                    </div>
                  </div>
                </div>
                <div className="lg:w-[45%] flex gap-3">
                  <div className="w-[40%] rounded-lg overflow-hidden h-[240px] md:h-[320px]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Dark%20editorial%20newsroom%20scene%20with%20modern%20screens%20displaying%20breaking%20news%2C%20dramatic%20red%20accent%20lighting%2C%20cinematic%20journalism%20photography%2C%20professional%20news%20agency%20atmosphere%2C%20dark%20charcoal%20and%20crimson%20color%20palette%2C%20dynamic%20composition&width=640&height=960&seq=about-brand-01&orientation=portrait"
                      alt="17吃瓜品牌形象"
                      title="17吃瓜品牌形象 - 网红八卦实时聚合平台"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="w-[60%] rounded-lg overflow-hidden h-[240px] md:h-[320px]">
                    <img
                      src="https://readdy.ai/api/search-image?query=Dark%20mysterious%20investigative%20journalism%20office%20with%20files%20and%20screens%2C%20dramatic%20red%20ambient%20lighting%2C%20cinematic%20noir%20photography%2C%20detective%20atmosphere%2C%20dark%20shadows%2C%20professional%20composition%2C%20deep%20charcoal%20and%20crimson%20palette&width=960&height=960&seq=about-brand-02&orientation=portrait"
                      alt="17吃瓜编辑团队"
                      title="17吃瓜编辑团队 - 全网热点实时追踪"
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Milestones / Timeline */}
        <section className="bg-background-100 py-10 md:py-14">
          <div className="container-page max-w-4xl">
            <div className="flex flex-col items-center text-center mb-10">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                <span className="text-primary-500 text-xs tracking-wider">发展历程</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                发展历程
              </h2>
              <p className="text-secondary-500 text-sm mt-2 font-light">
                从0到500万+，17吃瓜的成长之路
              </p>
            </div>

            <div className="relative">
              <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-primary-500/30 -translate-x-1/2 hidden md:block"></div>
              <div className="absolute left-4 top-0 bottom-0 w-px bg-primary-500/30 md:hidden"></div>
              <div className="space-y-6 md:space-y-8">
                {milestones.map((m, i) => (
                  <div key={i} className={`relative flex items-start gap-4 md:gap-0 ${i % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}>
                    <div className="hidden md:block md:w-1/2"></div>
                    <div className="flex-shrink-0 relative z-10">
                      <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-foreground-950 text-xs font-bold rounded-full">17</span>
                    </div>
                    <div className={`md:w-1/2 ${i % 2 === 0 ? 'md:pl-8 md:text-left' : 'md:pr-8 md:text-right'}`}>
                      <div className="bg-background-200 rounded-lg p-4">
                        <span className="text-primary-500 text-xs font-semibold">{m.year}</span>
                        <h4 className="text-foreground-800 text-sm font-semibold mt-1">{m.title}</h4>
                        <p className="text-secondary-500 text-xs mt-1 leading-relaxed">{m.desc}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* 用户口碑 */}
        <section className="bg-background-100 py-10 md:py-14">
          <div className="container-page max-w-4xl">
            <div className="flex flex-col items-center text-center mb-10">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                <span className="text-primary-500 text-xs tracking-wider">用户口碑</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                媒体评价 / 用户口碑
              </h2>
              <p className="text-secondary-500 text-sm mt-2 font-light">看看他们怎么说</p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {[
                { user: '某头部网红经纪公司HR', comment: '17吃瓜的内容真实度和更新速度在业内确实顶级，我们团队每天早上第一件事就是刷17吃瓜看今天有什么新瓜，很多选题灵感都来自这里。', identity: 'MCN机构从业人员' },
                { user: '某娱乐自媒体大V', comment: '作为一个从业10年的娱乐记者，17吃瓜的消息准确率让我惊讶。很多独家爆料比传统媒体的报道还要快半天以上。', identity: '行业资深媒体人' },
                { user: '社交媒体运营', comment: '每次不知道发什么内容的时候就来17吃瓜逛逛，总能找到最热门的话题当作素材。帮我省了大量的选题时间。', identity: '某MCN机构运营' },
              ].map((item, idx) => (
                <div key={idx} className="bg-white border border-background-200 rounded-lg p-6 flex flex-col">
                  <i className="ri-double-quotes-l text-primary-500 text-2xl mb-3 opacity-30"></i>
                  <p className="text-secondary-600 text-sm leading-relaxed flex-1 mb-4">
                    {item.comment}
                  </p>
                  <div className="border-t border-background-200 pt-4">
                    <p className="text-foreground-800 text-sm font-semibold">{item.user}</p>
                    <p className="text-secondary-500 text-xs mt-0.5">{item.identity}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Business Cooperation */}
        <section className="bg-background-100 py-10 md:py-14">
          <div className="container-page max-w-4xl">
            <div className="flex flex-col items-center text-center mb-10">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                <span className="text-primary-500 text-xs tracking-wider">商务合作</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                商务合作
              </h2>
              <p className="text-secondary-500 text-sm mt-2 font-light">
                多种合作方式，共赢吃瓜流量红利
              </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {coopTypes.map((coop, i) => (
                <div key={i} className="bg-background-200 rounded-lg p-5 flex gap-4 transition-transform hover:-translate-y-1 duration-300">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500/15 rounded-lg flex-shrink-0">
                    <i className={`${coop.icon} text-primary-500 text-lg`}></i>
                  </span>
                  <div>
                    <h4 className="text-foreground-800 text-sm font-semibold mb-1">{coop.title}</h4>
                    <p className="text-secondary-500 text-xs leading-relaxed">{coop.desc}</p>
                  </div>
                </div>
              ))}
            </div>

            <div className="bg-background-200 rounded-lg p-6 md:p-8">
              <h3 className="text-foreground-800 text-base font-semibold mb-4 text-center">合作联系方式</h3>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                <div className="text-center p-4 bg-background-300/60 rounded-lg">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500/15 rounded-full mx-auto mb-3">
                    <i className="ri-mail-line text-primary-500 text-lg"></i>
                  </span>
                  <p className="text-foreground-800 text-sm font-medium mb-1">商务邮箱</p>
                  <p className="text-secondary-500 text-xs">{brandInfo.contact.email}</p>
                </div>
                <div className="text-center p-4 bg-background-300/60 rounded-lg">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500/15 rounded-full mx-auto mb-3">
                    <i className="ri-wechat-line text-primary-500 text-lg"></i>
                  </span>
                  <p className="text-foreground-800 text-sm font-medium mb-1">微信联系</p>
                  <p className="text-secondary-500 text-xs">{brandInfo.contact.wechat}</p>
                </div>
                <div className="text-center p-4 bg-background-300/60 rounded-lg">
                  <span className="w-10 h-10 flex items-center justify-center bg-primary-500/15 rounded-full mx-auto mb-3">
                    <i className="ri-weibo-line text-primary-500 text-lg"></i>
                  </span>
                  <p className="text-foreground-800 text-sm font-medium mb-1">微博官号</p>
                  <p className="text-secondary-500 text-xs">{brandInfo.contact.weibo}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 常见问题 */}
        <section className="bg-background-100 py-10 md:py-14">
          <div className="container-page max-w-3xl">
            <div className="flex flex-col items-center text-center mb-10">
              <div className="flex items-center gap-2 mb-2">
                <span className="w-2 h-2 bg-primary-500 rounded-full"></span>
                <span className="text-primary-500 text-xs tracking-wider">常见问题</span>
              </div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
                常见问题
              </h2>
              <p className="text-secondary-500 text-sm mt-2 font-light">关于17吃瓜的常见疑问解答</p>
            </div>
            <div className="space-y-3">
              {[
                { q: '17吃瓜的信息来源可靠吗？', a: '17吃瓜采用严格的匿名信息审核机制，所有爆料内容均经过多维度交叉验证。我们设有专门的审核团队，对每一条爆料进行真实性评估，确保呈现给用户的信息经过充分核验。' },
                { q: '如何向17吃瓜进行匿名爆料？', a: '您可以通过页面上的匿名爆料通道提交信息。17吃瓜采用端到端加密技术，所有爆料人信息均被严格加密存储，不会向任何第三方透露爆料人身份信息。' },
                { q: '17吃瓜的信息更新频率如何？', a: '17吃瓜实行24小时滚动更新机制，热点事件发生后的30分钟内即可上线第一手信息。我们设有自动化监控系统与人工编辑团队相结合的内容更新体系。' },
                { q: '如何申请删除不实信息？', a: '如发现平台存在不实信息，可通过官方联系邮箱提交删除申请，并附上相关证明文件。我们会在收到申请的48小时内完成核实并做出相应处理。' },
              ].map((item, idx) => (
                <div key={idx} className="bg-white border border-background-200 rounded-lg overflow-hidden">
                  <button
                    className="w-full px-6 py-4 flex items-center justify-between text-left cursor-pointer"
                    onClick={() => {
                      const el = document.getElementById(`about-faq-${idx}`);
                      if (el) {
                        const isOpen = !el.classList.contains('hidden');
                        if (isOpen) {
                          el.classList.add('hidden');
                        } else {
                          el.classList.remove('hidden');
                        }
                      }
                    }}
                  >
                    <span className="text-foreground-800 text-sm font-medium pr-4">{item.q}</span>
                    <span className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                      <i className="ri-add-line text-secondary-500 text-lg"></i>
                    </span>
                  </button>
                  <div id={`about-faq-${idx}`} className="hidden px-6 pb-4">
                    <p className="text-secondary-600 text-sm leading-relaxed">{item.a}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="flex flex-col lg:flex-row">
          <div className="lg:w-1/2 h-[280px] md:h-[380px] relative overflow-hidden">
            <img
              src="https://readdy.ai/api/search-image?query=Dark%20professional%20office%20with%20team%20collaboration%20scene%2C%20dramatic%20red%20ambient%20lighting%2C%20cinematic%20corporate%20photography%2C%20modern%20media%20company%20atmosphere%2C%20dark%20charcoal%20and%20crimson%20palette%2C%20dynamic%20team%20composition&width=960&height=760&seq=about-cta-bg&orientation=landscape"
              alt="商务合作 / 加入我们 - 17吃瓜"
              className="absolute inset-0 w-full h-full object-cover object-top"
              loading="lazy"
            />
            <div className="absolute inset-0 bg-background-950/60"></div>
            <div className="relative z-10 h-full flex flex-col justify-between p-8 md:p-12">
              <span className="text-secondary-500 text-xs tracking-wider self-start">加入我们</span>
              <div>
                <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-950 leading-tight">
                  一起做最牛
                  <br />
                  吃瓜平台
                </h2>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 bg-background-950 flex items-center justify-center py-10 md:py-14 px-8">
            <div className="text-center max-w-md">
              <h2 className="text-3xl md:text-4xl font-extrabold text-foreground-50 leading-tight mb-6">
                有料就爆
                <br />
                不怕事大
              </h2>
              <p className="text-secondary-400 text-sm leading-relaxed mb-8">
                无论您是品牌方、广告主、内容创作者还是求职者，
                17吃瓜都期待与您合作。我们提供灵活的商务合作方案，
                助您精准触达千万吃瓜用户。
              </p>
              <a
                href={`mailto:${brandInfo.contact.email}`}
                className="inline-flex items-center gap-2 bg-background-950 text-foreground-50 font-semibold text-sm px-8 py-3.5 rounded-full cursor-pointer hover:bg-background-800 transition-all whitespace-nowrap"
              >
                立即联系
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}